import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import { FaCode, FaSatelliteDish } from 'react-icons/fa';
import { SiCsharp, SiC } from "react-icons/si";
import { FiCloud } from 'react-icons/fi';
import { BiChip, BiNetworkChart } from 'react-icons/bi';
import { AiOutlineCloudSync } from 'react-icons/ai';
import { FaRobot } from 'react-icons/fa';
import {
  DiJavascript1,
  DiReact,
  DiAndroid,
  DiPython,
  DiGit,
  DiJava,
  DiDatabase,
  DiLinux,
  DiAngularSimple
} from "react-icons/di";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiC />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <CgCPlusPlus />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiCsharp />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiPython />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJava />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaCode />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaRobot />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiAndroid />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiAngularSimple />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiLinux />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiDatabase />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <BiChip />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaSatelliteDish />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FiCloud />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <BiNetworkChart />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <AiOutlineCloudSync />
      </Col>
    </Row>
  );
}

export default Techstack;
